/*jshint esversion: 11 */

// Globais chamadas de dentro de modais (x-data/@click). No bundle e não em <script> inline no
// Blade: o Livewire 3 insere o HTML do modal via template.innerHTML e nunca executa <script>
// (mesmo problema do window.phoneInput, ver libs/intl-tel-input.js).

// Aceita "H:MM" ou "HH:MM" entre 00:00 e 23:59 (add-availability).
window.validateHour = function (h) {
    return h.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/);
};

// Monta a URL de embed do Spotify a partir do link colado (integrations/spotify).
window.buildLink = function (link) {
    const id = link.substring(link.lastIndexOf('/') + 1).split('?')[0];

    if (link.includes('playlist')) {
        return 'https://open.spotify.com/embed/playlist/' + id;
    } else if (link.includes('album')) {
        return 'https://open.spotify.com/embed/album/' + id;
    } else if (link.includes('track')) {
        return 'https://open.spotify.com/embed/track/' + id;
    }

    return 'https://open.spotify.com/embed/artist/' + id;
};
